:host {
  width: 100%;
  display: block;
  margin-bottom: var(--cms-components-mb);
}

.moving-image-subheading {
  display: flex;
  font-size: var(--cms-adaptive-special-subheading-size);
  font-family: var(--cms-brandfont2);
  line-height: var(--cms-line-height-133);
  font-weight: var(--cms-heading-base-font-weight);
}

.cta-svg {
  display: flex;
  align-items: center;
}

.moving-image-content {
  position: relative;
  max-height: px-to-rem(700);
}

.moving-image-video {
  width: 100%;
  max-height: px-to-rem(700);
  object-fit: cover;
  display: flex;
  aspect-ratio: 1.5;
}

.headline-wrapper-inner {
  box-sizing: border-box;
  @include cms-margin-center;
  margin-top: -2rem;
  padding: var(--cms-spacing-100) var(--cms-spacing-200);
  position: relative;
  max-width: calc(100% - var(--cms-spacing-200));
  z-index: 0;
  background-size: 100% 100%;

}

cms-headline {
  --cms-font-size: var(--cms-adaptive-special-headline-size);
}

cms-headline,
.moving-image-subheading {
  color: var(--cms-semanticColors-primary-textOnBackground);
}

.arrow-shaft-right-white {
  vertical-align: middle;
}

.moving-image-link {
  text-decoration: none;
}

@include media-width($breakpoint-sm) {
  .headline-wrapper-inner {
    bottom: var(--cms-spacing-100);
    left: var(--cms-spacing-100);
    position: absolute;
    width: auto;
  }
}

@include media-width($breakpoint-md) {
  .headline-wrapper {
    max-width: var(--cms-container-max-width);
    position: relative;

    @include cms-margin-center;
  }

  .headline-wrapper-inner {
    bottom: var(--cms-spacing-400);
  }

}



@media (width >=1921px) {
  .moving-image-container {
    max-width: px-to-rem(1920);
    padding-top: var(--cms-spacing-200);
    @include cms-margin-center;
  }

  .moving-image-video {
    max-width: px-to-rem(1920);
  }
}